import React from "react";

interface OwnProps {
    width?: number;
    height?: number;
    fill?: string;
}

export const XIcon = (props: OwnProps) => {
    const { width = 22, height = 21, fill = "white" } = props;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                y1="-1"
                x2="26.9809"
                y2="-1"
                transform="matrix(-0.741266 0.671212 -0.627957 -0.778248 20 1)"
                stroke={fill}
                stroke-width="2"
            />
            <line
                y1="-1"
                x2="27.2524"
                y2="-1"
                transform="matrix(0.73388 0.67928 -0.636293 0.771448 0 2.48804)"
                stroke={fill}
                stroke-width="2"
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/components/Icons/XIcon.tsx